import { TextShow } from 'Utils/Helpers/TextShow';
import * as icons from 'react-bootstrap-icons';
import Header from '../Header';
import NewType from './new';
import ListTypes from './list';
import ListBanks from './list';
import NewBank from './new';

const title = 'کارت‌خوان';

export default function SetBanks() {
  return (
    <>
      <Header title={title} justText />
      <div className='mt-4'>
        <TextShow
          title={"تنظیمات دستگاه‌های کارت‌خوان مطب"}
          icon={<icons.Bank size={18} />}
          justText
          className={'no-hide text-muted'}
        />
        <div className='setting-app-types'>
          <NewBank />
          <ListBanks />
        </div>
      </div>
    </>
  );
}